import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { GoalListComponent } from './goal-list/goal-list.component';
import { GoalEditComponent } from './goal-edit/goal-edit.component';
import { ProviderListService } from '../core/service/grid-data/grid-data-provider.service';

@NgModule({
  declarations: [
    GoalListComponent,
    GoalEditComponent
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    GoalListComponent
  ],
  providers: [ProviderListService]
})
export class GoalModule { }
